import React, { useEffect, useState } from 'react';
import {Link, useNavigate} from "react-router-dom";
import { toast } from "react-toastify";
import {useForm} from "react-hook-form";
import UnitAPI from "../../../apis/adminApi/UnitAPI";
import Field from "../../forms/Field";
import MyButton from "../../assets/MyButton";

const AdminAddUnit = () => {
    const { formState } = useForm();
    const { isSubmitting } = formState;
    const navigate = useNavigate();

    const [showLoader, setShowLoader] = useState(false);

    const [unit, setUnit] = useState({
        unit_name : "", unit_sign : ""
    });

    const [errors, setErrors] = useState({
        unit_name : "", unit_sign : ""
    });

    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setUnit({...unit, [name] : value})
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{

            setShowLoader(true);
            await UnitAPI.create(unit);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Unit ajouté avec succès");
            navigate("/admin/units");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire !");
            }
        }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    <div className="card">
                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                <h5 className="card-title">Ajouter une unité</h5>
                                <div className="row">
                                    <div className="col-6">
                                        <Field
                                            name="unit_name"
                                            error={errors.unit_name}
                                            value={unit.unit_name}
                                            onChange={handleChange}
                                            label="Nom de l'unité"
                                            placeholder="Nom"
                                        />
                                    </div>
                                    <div className="col-6">
                                        <Field
                                            name="unit_sign"
                                            error={errors.unit_sign}
                                            value={unit.unit_sign}
                                            onChange={handleChange}
                                            label="Symbole de l'unité"
                                            placeholder="Symbole"
                                        />
                                    </div>
                                </div>


                                <MyButton
                                    text="Ajouter"
                                    onSubmit={handleSubmit}
                                    loading={showLoader}
                                    disabled={showLoader}
                                />
                                <Link to="/admin/units" className="btn btn-info mx-2">Revenir aux unités</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminAddUnit;
